export function downArrowEl({ component, duration, id }) {
  function press(event) {
    event.preventDefault()
    event.stopPropagation()

    component.moveDown({ id, component })
  }

  return {
    kind: 'button',
    className: 'button',
    title: 'move down',
    value: duration,
    attributes: {
      'down-arrow': ''
    },
    styles: {
      display: 'inline-block',
      marginLeft: '4px'
    },
    on: {
      click: press,
      keypress: press
    },
    children: [
      {
        kind: 'div',
        className: 'icon-downarrow',
        styles: {
          height: '20px',
          width: '20px',
          backgroundSize: 'contain'
        }
      }
    ]
  }
}
